export default {
    label_task:{
        en:"Six Crop Sales Planning",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Six Crop Sales Planning",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Six Crop Sales Planning",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Six Crop Sales Planning",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_market_size_total :{
        en:"Total Market Size",
        bn:'ব্যবহারকারীরা'
    },
    label_pocket_market :{
        en:"Pocket Market",
        bn:'ব্যবহারকারীরা'
    },
    label_forecast :{
        en:"Forecast",
        bn:'ব্যবহারকারীরা'
    },
    label_dealer_meeting :{
        en:"# of Dealer Meeting ",
        bn:'ব্যবহারকারীরা'
    },
    label_farmer_meeting :{
        en:"# of Farmer Meeting",
        bn:'ব্যবহারকারীরা'
    },
    label_num_demo :{
        en:"# of Demo",
        bn:'ব্যবহারকারীরা'
    },
    label_num_result_sharing :{
        en:"# of Result Sharing",
        bn:'ব্যবহারকারীরা'
    },
    label_num_field_day :{
        en:"# of Field Day",
        bn:'ব্যবহারকারীরা'
    },
    label_total_type_entered:{
        en:"# of types data",
        bn:"কর্মচারী আইডি"
    },
    label_total_crop_entered:{
        en:"# of Crop data",
        bn:"কর্মচারী আইডি"
    },

}